import { Controller } from "@hotwired/stimulus";
import zxcvbn from "zxcvbn";

export default class extends Controller {
  static weakPasswords = ["stekker", "stekker.app", "stekkerapp", "stekker.com", "stekkercom"];
  static targets = ["quality", "feedback"];

  static values = {
    passwordQualities: Object,
    weakPasswords: Array,
  };

  update({ target: { value } }) {
    const { score } = zxcvbn(value, this.constructor.weakPasswords);
    const passwordPresent = value.length > 0;
    const hue = (138 / 4) * score;
    const color = `hsl(${hue}, 44%, 55%)`;

    this.feedbackTargets.forEach((target, index) => {
      target.style.backgroundColor = passwordPresent && index <= score ? color : null;
    });

    this.qualityTarget.innerText = this.passwordQualitiesValue[score];
  }
}
